/**
 * @generated SignedSource<<821ebe688ad89d010a315bace3532ba0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateQuoteContentBlockInput = {
  id: string;
  name: string;
  bodyJson: string;
  isDefault?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateQuoteContentBlockMutation$variables = {
  input: UpdateQuoteContentBlockInput;
};
export type updateQuoteContentBlockMutation$data = {
  readonly updateQuoteContentBlock: {
    readonly company: {
      readonly id: string;
      readonly quoteContentBlocks: ReadonlyArray<{
        readonly id: string;
        readonly sectionType: string | null;
        readonly name: string | null;
        readonly bodyJson: string | null;
        readonly isDefault: boolean | null;
      } | null> | null;
    } | null;
    readonly quoteContentBlock: {
      readonly id: string;
      readonly sectionType: string | null;
      readonly name: string | null;
      readonly bodyJson: string | null;
      readonly isDefault: boolean | null;
    } | null;
  } | null;
};
export type updateQuoteContentBlockMutation = {
  variables: updateQuoteContentBlockMutation$variables;
  response: updateQuoteContentBlockMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  (v1/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "sectionType",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "bodyJson",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "isDefault",
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateQuoteContentBlockPayload",
    "kind": "LinkedField",
    "name": "updateQuoteContentBlock",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "QuoteContentBlock",
            "kind": "LinkedField",
            "name": "quoteContentBlocks",
            "plural": true,
            "selections": (v2/*: any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QuoteContentBlock",
        "kind": "LinkedField",
        "name": "quoteContentBlock",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateQuoteContentBlockMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateQuoteContentBlockMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "1c871573ff033ce63ae752a5e740039e",
    "id": null,
    "metadata": {},
    "name": "updateQuoteContentBlockMutation",
    "operationKind": "mutation",
    "text": "mutation updateQuoteContentBlockMutation(\n  $input: UpdateQuoteContentBlockInput!\n) {\n  updateQuoteContentBlock(input: $input) {\n    company {\n      id\n      quoteContentBlocks {\n        id\n        sectionType\n        name\n        bodyJson\n        isDefault\n      }\n    }\n    quoteContentBlock {\n      id\n      sectionType\n      name\n      bodyJson\n      isDefault\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "44981089e7e5f7d054fa0e3793658001";

export default node;
